import { atom } from 'nanostores';

// Auxiliary store part to set availability of previous and next buttons.
// Might be used when playlist doesn't make sense on client side.
export function createNavigationStore() {
  const $prevAvailable = atom(false);

  function setPrevAvailable(available: boolean) {
    $prevAvailable.set(available);
  }

  const $nextAvailable = atom(false);

  function setNextAvailable(available: boolean) {
    $nextAvailable.set(available);
  }

  return {
    $prevAvailable,
    $nextAvailable,
    setPrevAvailable,
    setNextAvailable,
  };
}
